import Vue from 'vue/dist/vue.js';
import Router from 'vue-router';
import Home from '@/components/Home';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      children: [
        {
          path: ':page',
          name: 'Home',
          component: Home,
        },
      ]
    },
  ],
});